function autocompleteAddress(addressInputId) {
  const element = document.getElementById(addressInputId);

  // The form must not be submitted by pressing enter. This will prevent the address
  // from being correctly composed.

  if (element) {
    $(window).keydown(function(e) {
      if(e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  }

  const options = {
    fields: ['address_components'],
    types: ['address'],
  };

  if (element) {
    let autocomplete = new google.maps.places.Autocomplete(element, options);
    google.maps.event.addListener(autocomplete, 'place_changed', onPlaceChanged);
  }

  function onPlaceChanged() {
    let place = this.getPlace();

    const streetAddress = document.getElementById(addressInputId.replace('address','street_address_and_number'));
    const zipCode = document.getElementById(addressInputId.replace('address','zip_code'));
    const country = document.getElementById(addressInputId.replace('address','country'));
    const city = document.getElementById(addressInputId.replace('address','city'));

    const streetNumber = findStreetNumber(place.address_components);

    place.address_components.forEach(component => {
      if (component.types.includes('route')) {
        streetAddress.value = streetNumber + ' ' + component.short_name;
      } else if (component.types.includes('postal_code')) {
        zipCode.value = component.short_name;
      } else if (component.types.includes('country')) {
        country.value = component.short_name;
      } else if(component.types.includes('locality')) {
        city.value = component.short_name;
      }
    })
  }

  const findStreetNumber = (placeComponents) => {
    for (const [, value] of Object.entries(placeComponents)) {
      if (value.types.includes('street_number')) {
        return value.short_name;
      }
    }
    return '';
  };
}

autocompleteAddress('users_profile_user_attributes_address');
autocompleteAddress('users_profile_user_attributes_fiscal_address');
autocompleteAddress('users_profile_legal_entity_attributes_address');
autocompleteAddress('users_profile_distributor_legal_entity_attributes_address');
